import { render, staticRenderFns } from "./ButtonForward.vue?vue&type=template&id=7d851a6c&scoped=true"
import script from "./ButtonForward.vue?vue&type=script&lang=js"
export * from "./ButtonForward.vue?vue&type=script&lang=js"
import style0 from "./ButtonForward.vue?vue&type=style&index=0&id=7d851a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d851a6c",
  null
  
)

export default component.exports